export default "__VITE_ASSET__Bys8La_E__"